<script>
    import LyButtons from './LyButtons.svelte';
    import LySection from '../components/LySection.svelte';

    /**
     * @type {{
     *     tag?: string,
     *     bg?: boolean | string,
     *     mt?: number | boolean | string,
     *     mb?: number | boolean | string,
     *     wrapper?: boolean | string,
     *     children?: import("svelte").Snippet,
     *     [key: string]: any,
     * }}
     */
    let { tag = 'div', bg = true, mt = 0, mb = 0, wrapper = true, children, ...restProps } = $props();
</script>

<LyButtons {...restProps} {tag} {wrapper} {mb} {mt} padding={true} border={true} shadow={true} {bg}>
    {@render children?.()}
</LyButtons>
